import React, { useContext, useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import FlashTourPackageOption from './FlashTourPackageOption'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import config from 'constants/config'
import { sortBy } from 'lib/array/arrayUtils'
import Heading from 'LuxKit/Typography/Heading'
import CurrencyContext from 'contexts/currencyContext'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { isDepositAvailableOnOffer } from 'lib/payment/depositsUtils'
import cn from 'clsx'

const Sheet = styled.div`
  padding-top: ${rem(32)};
  padding-bottom: ${rem(32)};
`

const PackageSelectionWrapper = styled(VerticalSpacer)`
  ${mediaQueryUp.tablet} {
    position: relative;
  }
`

interface Props {
  availableForPurchase: boolean
  offer: App.TourOffer
  packages: Array<App.TourPackage>
  defaultDepositAmountPercentage: number
}

function FlashTourPackageOptions(props: Props) {
  const {
    offer,
    availableForPurchase,
  } = props

  const sortedOptions = useMemo(() => sortBy(offer.packages, pkg => pkg.sortOrder, 'asc'), [offer.packages])
  const currentCurrency = useContext(CurrencyContext)
  const depositsAvailable = isDepositAvailableOnOffer(offer, currentCurrency, undefined, offer.lowestPricePackage.price)

  return (
    <Sheet id="Package-Options">
      <LayoutContainer>
        <VerticalSpacer gap={24}>
          <Heading variant="heading2" format="titlecase" as="h2" align="center">
            {config.brandConfig.travelSynonym} Options
          </Heading>
          <PackageSelectionWrapper gap={16} className={cn({ deposits: depositsAvailable })}>
            {sortedOptions.map((packageOption) => <FlashTourPackageOption
              key={packageOption.uniqueKey}
              offer={offer}
              packageOption={packageOption}
              availableForPurchase={availableForPurchase}
              useNightDuration
            />)}
          </PackageSelectionWrapper>
        </VerticalSpacer>
      </LayoutContainer>
    </Sheet>
  )
}

export default FlashTourPackageOptions
